import { __extends } from "tslib";
import { Info } from "./Info";
var InstanceInfo = /** @class */ (function (_super) {
    __extends(InstanceInfo, _super);
    function InstanceInfo(abc, name, superName, flags, protectedNs, interfaceNameIndices, initializer, traits) {
        var _this = _super.call(this) || this;
        _this.abc = abc;
        _this.name = name;
        _this.superName = superName;
        _this.flags = flags;
        _this.protectedNs = protectedNs;
        _this.interfaceNameIndices = interfaceNameIndices;
        _this.initializer = initializer;
        _this.traits = traits;
        _this.classInfo = null;
        _this.runtimeTraits = null;
        _this._interfaces = null;
        return _this;
    }
    InstanceInfo.prototype.getInitializer = function () {
        if (typeof this.initializer === "number") {
            this.initializer = this.abc.getMethodInfo(this.initializer);
        }
        return this.initializer;
    };
    InstanceInfo.prototype.getName = function () {
        if (typeof this.name === "number") {
            this.name = this.abc.getMultiname(this.name);
        }
        return this.name;
    };
    InstanceInfo.prototype.getClassName = function () {
        var name = this.getName();
        if (name.namespaces[0].uri) {
            return name.namespaces[0].uri + "." + name.name;
        }
        return name.name;
    };
    InstanceInfo.prototype.getSuperName = function () {
        if (typeof this.superName === "number") {
            this.superName = this.abc.getMultiname(this.superName);
        }
        return this.superName;
    };
    InstanceInfo.prototype.getInterfaces = function (ownerClass) {
        if (this._interfaces) {
            return this._interfaces;
        }
        var superClassInterfaces;
        var superClass = ownerClass.superClass;
        if (superClass) {
            superClassInterfaces = superClass.classInfo.instanceInfo.getInterfaces(superClass);
        }
        var SetCtor = Set;
        var interfaces = this._interfaces = new SetCtor(superClassInterfaces);
        for (var i = 0; i < this.interfaceNameIndices.length; i++) {
            var mn = this.abc.getMultiname(this.interfaceNameIndices[i]);
            var type = this.abc.applicationDomain.getClass(mn);
            interfaces.add(type);
            var implementedInterfaces = type.classInfo.instanceInfo.getInterfaces(type);
            implementedInterfaces.forEach(function (iface) { return interfaces.add(iface); });
        }
        return interfaces;
    };
    InstanceInfo.prototype.toString = function () {
        return "InstanceInfo " + this.getName().name;
    };
    InstanceInfo.prototype.toFlashlogString = function () {
        return this.getName().toFlashlogString();
    };
    InstanceInfo.prototype.trace = function (writer) {
        writer.enter("InstanceInfo: " + this.getName());
        this.superName && writer.writeLn("Super: " + this.getSuperName());
        this.traits.trace(writer);
        writer.outdent();
    };
    InstanceInfo.prototype.isInterface = function () {
        return !!(this.flags & 4 /* ClassInterface */);
    };
    InstanceInfo.prototype.isSealed = function () {
        return !!(this.flags & 1 /* ClassSealed */);
    };
    InstanceInfo.prototype.isFinal = function () {
        return !!(this.flags & 2 /* ClassFinal */);
    };
    return InstanceInfo;
}(Info));
export { InstanceInfo };
